import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Star = createSvgIcon(
  () => (
    <path d="M17.5609 1.76562L12.9906 11.1172L2.65469 12.5938C0.826561 12.875 0.123436 15.125 1.45937 16.4609L8.84219 23.7031L7.08437 33.8984C6.80312 35.7266 8.77187 37.1328 10.3891 36.2891L19.6 31.4375L28.7406 36.2891C30.3578 37.1328 32.3266 35.7266 32.0453 33.8984L30.2875 23.7031L37.6703 16.4609C39.0062 15.125 38.3031 12.875 36.475 12.5938L26.2094 11.1172L21.5687 1.76562C20.7953 0.148438 18.4047 0.078125 17.5609 1.76562Z" />
  ),
  '0 0 40 38'
);
